import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Plus, X, LinkSimple, LinkBreak } from "@phosphor-icons/react";
import { errMsg, fmtBRL } from "@/lib/medicoes";

function NovoFornecedor({ onClose, onSaved }) {
  const [f, setF] = useState({ name: "", email: "", razao_social: "", cnpj: "", password: "" });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      const { data } = await api.post("/admin/fornecedores", { ...f, password: f.password || null });
      toast.success(data.password_generated ? `Fornecedor criado. Senha gerada: ${data.password_generated}` : "Fornecedor criado", { duration: 15000 });
      onSaved();
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  const inp = "tce-input w-full px-3 py-2.5 rounded-md text-sm";
  return (
    <div className="fixed inset-0 z-[100] bg-black/80 flex items-center justify-center p-4" onClick={onClose}>
      <form onSubmit={submit} onClick={(e) => e.stopPropagation()} className="tce-card w-full max-w-lg p-6 space-y-3" data-testid="novo-fornecedor-modal">
        <div className="flex justify-between items-center"><div className="font-heading text-xl">Novo usuário fornecedor</div><button type="button" onClick={onClose}><X size={18} /></button></div>
        {[["razao_social", "Razão social"], ["cnpj", "CNPJ/CPF"], ["name", "Nome do representante"], ["email", "E-mail de acesso"], ["password", "Senha (opcional, gerada se vazia)"]].map(([k, l]) => (
          <div key={k}><label className="uppercase-label !text-[10px] block mb-1">{l}</label>
            <input data-testid={`nf-${k}`} required={k !== "password"} type={k === "email" ? "email" : "text"} value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} className={inp} /></div>
        ))}
        <p className="text-[11px] text-[#94A3B8]">O fornecedor verá automaticamente os contratos cadastrados com este CNPJ. Vínculos adicionais podem ser feitos depois.</p>
        <button disabled={busy} data-testid="nf-save" className="w-full py-2.5 rounded-md bg-[#FFDF00] text-[#0F172A] font-medium text-sm disabled:opacity-50">{busy ? "Salvando…" : "Criar fornecedor"}</button>
      </form>
    </div>
  );
}

function Vinculos({ forn, onClose }) {
  const [d, setD] = useState(null);
  const [cid, setCid] = useState("");
  const [busca, setBusca] = useState([]);
  const load = () => api.get(`/admin/fornecedores/${forn.id}/contratos`).then((r) => setD(r.data));
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (cid.length < 2) { setBusca([]); return; }
    const t = setTimeout(() => api.get("/contracts", { params: { search: cid, limit: 8 } }).then((r) => setBusca(r.data.items || [])), 300);
    return () => clearTimeout(t);
  }, [cid]);
  const acao = async (contract_id, a) => {
    try { await api.post(`/admin/fornecedores/${forn.id}/vinculos`, { contract_id, acao: a }); toast.success(a === "vincular" ? "Contrato vinculado" : "Contrato desvinculado"); load(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="fixed inset-0 z-[100] bg-black/80 flex items-center justify-center p-4" onClick={onClose}>
      <div onClick={(e) => e.stopPropagation()} className="tce-card w-full max-w-3xl max-h-[90vh] overflow-y-auto p-6 space-y-4" data-testid="vinculos-modal">
        <div className="flex justify-between items-center"><div><div className="uppercase-label">Vínculos contratuais</div><div className="font-heading text-xl">{forn.razao_social}</div></div><button onClick={onClose}><X size={18} /></button></div>
        <div>
          <input data-testid="vinc-busca" value={cid} onChange={(e) => setCid(e.target.value)} placeholder="Buscar contrato por número/objeto para vincular…" className="tce-input w-full px-3 py-2.5 rounded-md text-sm" />
          {busca.map((c) => (
            <div key={c.id} className="flex items-center justify-between text-sm py-1.5 border-b border-[#334155]/50">
              <span className="truncate"><span className="font-mono text-[#FFDF00]">{c.numero}</span> · {c.objeto?.slice(0, 60)} · {c.municipio_nome}</span>
              <button onClick={() => acao(c.id, "vincular")} data-testid={`vinc-add-${c.id}`} className="text-xs text-[#22C55E] flex items-center gap-1 shrink-0"><LinkSimple size={12} /> vincular</button>
            </div>
          ))}
        </div>
        <div className="uppercase-label">Contratos com acesso ({d?.items.length || 0})</div>
        {d?.items.map((c) => (
          <div key={c.id} className="flex items-center justify-between text-sm py-1.5 border-b border-[#334155]/50" data-testid={`vinc-row-${c.id}`}>
            <span className="truncate"><span className="font-mono text-[#FFDF00]">{c.numero}</span> · {c.objeto?.slice(0, 60)} · {fmtBRL(c.valor)}</span>
            <button onClick={() => acao(c.id, "desvincular")} data-testid={`vinc-del-${c.id}`} className="text-xs text-[#EF4444] flex items-center gap-1 shrink-0"><LinkBreak size={12} /> desvincular</button>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function AdminFornecedores() {
  const [items, setItems] = useState([]);
  const [novo, setNovo] = useState(false);
  const [vinc, setVinc] = useState(null);
  const load = () => api.get("/admin/fornecedores").then((r) => setItems(r.data.items));
  useEffect(() => { load(); }, []);
  const toggle = async (f) => {
    if (!window.confirm(`${f.active === false ? "Reativar" : "Desativar"} o acesso de ${f.razao_social}?`)) return;
    try { await api.put(`/admin/fornecedores/${f.id}`, { active: f.active === false }); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="space-y-6" data-testid="admin-fornecedores">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div><div className="uppercase-label">Administração</div><h1 className="font-heading text-4xl tracking-tight mt-2">Fornecedores</h1>
          <p className="text-sm text-[#94A3B8] mt-2">Usuários das empresas contratadas com acesso à Área do Fornecedor.</p></div>
        <button onClick={() => setNovo(true)} data-testid="novo-fornecedor-btn" className="px-4 py-2.5 rounded-md bg-[#FFDF00] text-[#0F172A] text-sm font-medium flex items-center gap-2"><Plus size={16} weight="bold" /> Novo fornecedor</button>
      </div>
      <div className="tce-card overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-[#1E293B] text-left"><tr>{["Razão social", "CNPJ", "Representante", "E-mail", "Contratos", "Situação", ""].map((h) => <th key={h} className="px-4 py-3 uppercase-label !text-[10px]">{h}</th>)}</tr></thead>
          <tbody>
            {!items.length && <tr><td colSpan={7} className="px-4 py-8 text-center text-[#94A3B8]">Nenhum fornecedor cadastrado.</td></tr>}
            {items.map((f, i) => (
              <tr key={f.id} className="border-t border-[#334155]" data-testid={`af-row-${i}`}>
                <td className="px-4 py-3">{f.razao_social}</td><td className="px-4 py-3 font-mono text-xs">{f.cnpj}</td>
                <td className="px-4 py-3 text-[#94A3B8]">{f.name}</td><td className="px-4 py-3 text-[#94A3B8]">{f.email}</td>
                <td className="px-4 py-3 font-mono">{f.contratos_total}</td>
                <td className="px-4 py-3"><button onClick={() => toggle(f)} data-testid={`af-toggle-${i}`} className={`text-xs ${f.active === false ? "text-[#EF4444]" : "text-[#22C55E]"}`}>{f.active === false ? "Inativo" : "Ativo"}</button></td>
                <td className="px-4 py-3"><button onClick={() => setVinc(f)} data-testid={`af-vinculos-${i}`} className="text-xs text-[#FFDF00] hover:underline">Gerenciar vínculos</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {novo && <NovoFornecedor onClose={() => setNovo(false)} onSaved={() => { setNovo(false); load(); }} />}
      {vinc && <Vinculos forn={vinc} onClose={() => { setVinc(null); load(); }} />}
    </div>
  );
}
